import { Dropdown, DropdownItem, DropdownMenu, DropdownTrigger } from "@nextui-org/react";
import { Dialog } from "primereact/dialog";
import { useState } from "react";

/* eslint-disable react/prop-types */
export default function Datatable ({data,editform,confirm2}) {

    const [modalVisible, setModalVisible] = useState(false);
  const [selectedContent, setSelectedContent] = useState("");

  const openContentModal = (content) => {
    setSelectedContent(content);
    setModalVisible(true);
  };

    return (
        <>
        <Dialog header="Content Preview" visible={modalVisible} onHide={() => setModalVisible(false)} style={{ width: "50vw" }} breakpoints={{ "960px": "75vw", "641px": "100vw" }} maximizable>
            <div className="prose max-w-none" dangerouslySetInnerHTML={{ __html: selectedContent }}/>
        </Dialog>
         <div className=" bg-white border rounded-xl h-[400px] xl:h-[500px] 2xl:h-[700px] my-5 overflow-auto">
        <table className="min-w-full divide-y divide-gray-200 rounded-xl">
          <thead >
            <tr>
              <th scope="col" className="px-6 py-5 text-sm font-medium text-start">S.No</th>
              <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Current Affair Type</th>
              <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Category</th>
              <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Title</th>
              <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Content</th>
              <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Status</th>
              <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Action</th>

            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
          {data?.resdata?.map((item,index)=>
              <tr key={index}>
                <td scope="col" className="px-6 py-5 text-sm text-gray-500">{index+1}</td>
                <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.Current_Affair_Type}</td>
                <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.Category}</td>
                <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.Title}</td>
                <td scope="col" className="px-6 py-5 text-sm text-gray-500 cursor-pointer" onClick={() => openContentModal(item.Content)}>
                <i className="text-xl text-blue-500 fi fi-sr-overview"></i>
                </td>
                <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.Status}</td>
                <td scope="col" className="px-6 py-5 text-sm text-gray-500">
                  <Dropdown>
                    <DropdownTrigger>
                      <i className="text-lg cursor-pointer fi fi-rr-menu-dots-vertical"></i>
                    </DropdownTrigger>
                    <DropdownMenu aria-label="Dynamic Actions" >
                      <DropdownItem onPress={()=>editform(item)} color={"default"}>
                        Edit
                      </DropdownItem>
                      <DropdownItem onPress={()=>confirm2(item._id)} color={"danger"} className={"text-danger"}>
                        Delete
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                </td>
              </tr>
          )}
          </tbody>
        </table>
      </div>
        </>
    )
}